import { render } from "./PollList.vue?vue&type=template&id=080c4fd6"
import script from "./PollList.vue?vue&type=script&lang=js"
export * from "./PollList.vue?vue&type=script&lang=js"

import exportComponent from "/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__